import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import IconButton from '#components/a/IconButton'

function RenderFilters({selectedFilters, removeFilterCallback}) {
  return (
    <div className="list-container">
      {selectedFilters.courses.map(item => (
        <div key={item.id.toString()} className="filter-container">
          <span className="filter">{`${i18n.t('wissensportal_course')}: ${item.label}`}</span>
          <IconButton event={() => removeFilterCallback(item)} className="filter_delete" icon="close" />
        </div>
      ))}
      {selectedFilters.modules.map(item => (
        <div key={item.id.toString()} className="filter-container">
          <span className="filter">{`${i18n.t('wissensportal_module')}: ${item.label}`}</span>
          <IconButton event={() => removeFilterCallback(item)} className="filter_delete" icon="close" />
        </div>
      ))}
      {selectedFilters.status && (
        <div key="status-filter" className="filter-container">
          <span className="filter">{`${i18n.t('wissensportal_status_')}: ${i18n.t(
            `wissensportal_status_${selectedFilters.status}`,
          )}`}</span>
          <IconButton event={() => removeFilterCallback({type: 'STATUS'})} className="filter_delete" icon="close" />
        </div>
      )}
    </div>
  )
}

RenderFilters.propTypes = {
  selectedFilters: PropTypes.object.isRequired,
  removeFilterCallback: PropTypes.func.isRequired,
}

export default RenderFilters
